import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavTemplate = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#413735"
      d="M22 4v16h-2v-8h-9.5v6H18v2H2V4h20ZM4 18h4.5v-6H4v6Zm0-8h16V6H4v4Z"
    />
  </svg>
);
export default SvgNavTemplate;
